"use server";

import prisma from "@/lib/db";
import { UserLocalCache } from "@prisma/client";
import { verifyServerSession } from "@/utils/auth";

export const getUserLocalCacheByCurrentUser = async () => {
  let loggedInUuid: string | null;
  try {
    ({ loggedInUuid } = await verifyServerSession());
  } catch {
    return null;
  }

  if (!loggedInUuid) {
    return null;
  }

  return await prisma.userLocalCache.findFirst({
    where: {
      keycloakId: loggedInUuid,
    },
  });
};

export const getUserLocalCacheByHandle = async (handle: string) => {
  await verifyServerSession();
  return await prisma.userLocalCache.findFirst({
    where: {
      handle: handle,
    },
  });
};

/**
 * Update only the handle column.
 *
 * Useful for users that got a UserLocalCache before the creation of the
 * column handle.
 */
export const updateHandleByCurrentUser = async (
  handle: string,
) => {
  const { loggedInUuid } = await verifyServerSession();
  return await prisma.userLocalCache.update({
    where: {
      keycloakId: loggedInUuid,
    },
    data: {
      handle: handle,
    },
  });
};

export const updateNamesByCurrentUser = async (
  firstName: string,
  lastName: string,
) => {
  const { loggedInUuid } = await verifyServerSession();
  return await prisma.userLocalCache.update({
    where: {
      keycloakId: loggedInUuid,
    },
    data: {
      firstName: firstName,
      lastName: lastName,
    },
  });
};

export const updateNamesOrCreateLocalCache = async (
  firstName: string,
  lastName: string,
  handle: string
) => {
  const { loggedInUuid } = await verifyServerSession();

  let result: UserLocalCache;

  try {
    result = await prisma.userLocalCache.update({
      where: {
        keycloakId: loggedInUuid,
      },
      data: {
        firstName: firstName,
        lastName: lastName,
      },
    });
  } catch {
    result = await prisma.userLocalCache.create({
      data: {
        firstName,
        lastName,
        handle,
        keycloakId: loggedInUuid,
      },
    });
  }

  return result;
};
